var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.opendWebOptimumAlarm
    ? _c("div", { staticClass: "noti_browser" }, [
        _c("em", {
          staticClass: "noti_txt",
          domProps: { innerHTML: _vm._s(_vm.$t("gnb.optimum-msg")) }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "inp_check_wrap" }, [
          _c("input", {
            staticClass: "inp_check",
            attrs: { type: "checkbox", id: "check_notshow_again" },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "lb_txt", attrs: { for: "check_notshow_again" } },
            [_vm._v(_vm._s(_vm.$t("common.dont-show-again")))]
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn_close_noti",
            attrs: { type: "button" },
            on: { click: _vm.close }
          },
          [_vm._v(_vm._s(_vm.$t("common.button.close")))]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }